
import { defineComponent } from 'vue';
import { IDanhMucToaXeResponseBase } from '@/core/interfaces/ApiResponses';
import DanhMucToaXeService from '@/core/services/DanhMucToaXe.service';
import { swalErrNotification } from '@/core/helpers/utils';
import { generateTablePdf } from '@/core/helpers/generate-table-pdf';
import PdfViewerPage from '@/components/shared/pdf-viewer/PdfViewerPage.vue';
import { PDF_GENERATE_TABLE_DEFAULTS } from '@/components/shared/pdf-viewer/pdf-content.config';
import { pickDonViPdfExtra } from '@/components/shared/pdf-viewer/pdf-document-header';

const DANH_MUC_TOA_XE_PDF_COLUMNS = [
  { header: 'STT', width: 22, align: 'center' as const },
  { header: 'Tên', width: 90, align: 'left' as const },
  { header: 'Mã', width: 35, align: 'left' as const },
  { header: 'Nhóm cha', width: 55, align: 'left' as const },
  { header: 'Mô tả', width: 71, align: 'left' as const },
];

export default defineComponent({
  name: 'DanhMucToaXeListViewer',

  components: { PdfViewerPage },

  data() {
    return {
      items: [] as IDanhMucToaXeResponseBase[],
      searchTerm: '',
      pdfSource: null as string | null,
      isGenerating: false,
      tenDonVi: '',
      tenDonViCha: '',
    };
  },

  computed: {
    pdfFileName(): string {
      return 'danh-sach-nhom-toa-xe.pdf';
    },
  },

  methods: {
    async loadAndGenerate() {
      const queryS = this.$route.query.s;
      this.searchTerm = typeof queryS === 'string' ? queryS : '';

      try {
        this.isGenerating = true;
        this.pdfSource = null;

        const listResult = await DanhMucToaXeService.listAll(this.searchTerm);
        this.items = listResult.items;
        const { tenDonVi, tenDonViCha } = pickDonViPdfExtra(listResult.extra);
        this.tenDonVi = tenDonVi;
        this.tenDonViCha = tenDonViCha;
        this.pdfSource = await this.generatePdf();
      } catch (e) {
        swalErrNotification(e, 'Có lỗi khi tải danh sách nhóm toa xe');
      } finally {
        this.isGenerating = false;
      }
    },

    async generatePdf(): Promise<string> {
      const rows = this.items.map((item, index) => [
        String(index + 1),
        item.ten_danh_muc ?? '',
        item.ma_danh_muc ?? '',
        item.parent?.ten_danh_muc ?? '-',
        item.mo_ta || '-',
      ]);

      return generateTablePdf({
        ...PDF_GENERATE_TABLE_DEFAULTS,
        title: 'DANH SÁCH NHÓM TOA XE',
        subtitle: this.searchTerm ? `Từ khóa: ${this.searchTerm}` : undefined,
        columns: DANH_MUC_TOA_XE_PDF_COLUMNS,
        rows,
        documentHeader: {
          tenDonVi: this.tenDonVi,
          tenDonViCha: this.tenDonViCha,
          variant: 'masterList',
        },
      });
    },
  },

  mounted() {
    this.loadAndGenerate();
  },
});
